"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitAssessment = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var risk_1 = require("../../model/risk");
var service_1 = require("../../../library/base/service");
var SubmitAssessment = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SubmitAssessment, _super);
    function SubmitAssessment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '风险测评提交获取接口';
        _this.code = '100005';
        _this.desc = '风险测评提交获取接口';
        _this.requestParams = new risk_1.SubmitAssessmentRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SubmitAssessment;
}(service_1.BaseService));
exports.SubmitAssessment = SubmitAssessment;
//# sourceMappingURL=submitAssessment.js.map